module.exports = __webpack_public_path__ + "img/beaverjam-preview.de0d8e9f.gif";